/** Upload channel used when creating an asset/request or updating catalogue itemStatus. */
export type NgsildUploadMethod = 'SFTP' | 'API';

/**
 * Catalogue / asset-request type sent on SFTP or API upload submit.
 * Prefix reflects whether the asset was already VERIFIED before the upload config.
 */
export type VerifiedUploadRequestType =
  | 'VERIFIED-SFTP'
  | 'UNVERIFIED-SFTP'
  | 'VERIFIED-API'
  | 'UNVERIFIED-API';

/** True when itemStatus is a legacy or compound SFTP/API upload status. */
export function isSftpOrApiItemStatus(itemStatus: string | null | undefined): boolean {
  const s = String(itemStatus ?? '').trim().toUpperCase();
  return s === 'SFTP' || s === 'API' || s.endsWith('-SFTP') || s.endsWith('-API');
}

/** Extract SFTP vs API from legacy (`SFTP`) or compound (`VERIFIED-SFTP`) itemStatus. */
export function uploadMethodFromItemStatus(
  itemStatus: string | null | undefined,
): NgsildUploadMethod | null {
  const s = String(itemStatus ?? '').trim().toUpperCase();
  if (s === 'SFTP' || s.endsWith('-SFTP')) return 'SFTP';
  if (s === 'API' || s.endsWith('-API')) return 'API';
  return null;
}

/**
 * Build payload type / itemStatus for SFTP or API upload from the asset's current itemStatus.
 * VERIFIED (or VERIFIED-*) → VERIFIED-{method}; otherwise UNVERIFIED-{method}.
 */
export function resolveVerifiedUploadRequestType(
  currentItemStatus: string | null | undefined,
  method: NgsildUploadMethod,
): VerifiedUploadRequestType {
  const status = String(currentItemStatus ?? '').trim().toUpperCase();
  const isVerified = status === 'VERIFIED' || status.startsWith('VERIFIED-');
  return `${isVerified ? 'VERIFIED' : 'UNVERIFIED'}-${method}` as VerifiedUploadRequestType;
}
